<div class="activity-details solo">
    <c-auto-form config="setLanguage.autoFormConfig"></c-auto-form>
</div>